import { Pagination, PaginationItem, PaginationLink } from "reactstrap";

import styles from "components/ReactTable/Components/PaginationButtons/PaginationButtons.module.css";

export default function PaginationButtons({
    canNextPage,
    canPreviousPage,
    gotoPage,
    nextPage,
    pageCount,
    pageIndex,
    pageSize,
    paginationButtons,
    previousPage,
    recalculatePagination,
}) {
    function handleClickFirst() {
        let nextPageIndex = 0;
        gotoPage(nextPageIndex);
        recalculatePagination(pageSize, nextPageIndex);
    }

    function handleClickNext() {
        nextPage();
        let nextPageIndex = pageIndex + 1;
        if (!paginationButtons.includes(nextPageIndex)) {
            recalculatePagination(pageSize, nextPageIndex);
        }
    }

    function handleClickPrev() {
        previousPage();
        let nextPageIndex = pageIndex - 1;
        if (!paginationButtons.includes(nextPageIndex)) {
            recalculatePagination(pageSize, nextPageIndex);
        }
    }

    function handleClickLast() {
        let nextPageIndex = pageCount - 1;
        gotoPage(nextPageIndex);
        recalculatePagination(pageSize, nextPageIndex);
    }

    return (
        <Pagination className={styles.pagination}>
            <PaginationItem>
                <PaginationLink
                    first
                    onClick={handleClickFirst}
                    disabled={!canPreviousPage}
                />
            </PaginationItem>
            <PaginationItem>
                <PaginationLink
                    previous
                    onClick={handleClickPrev}
                    disabled={!canPreviousPage}
                />
            </PaginationItem>
            {paginationButtons.map((page) => (
                <PaginationItem key={page} active={page === pageIndex}>
                    <PaginationLink onClick={() => gotoPage(page)}>
                        {page + 1}
                    </PaginationLink>
                </PaginationItem>
            ))}
            <PaginationItem>
                <PaginationLink
                    next
                    onClick={handleClickNext}
                    disabled={!canNextPage}
                />
            </PaginationItem>
            <PaginationItem>
                <PaginationLink
                    last
                    onClick={handleClickLast}
                    disabled={!canNextPage}
                />
            </PaginationItem>
        </Pagination>
    );
}
